<template>
  <div>
    <va-card>
      <div>
        <v-server-table
          :columns="columns"
          :options="tableOptions"
          id="patientAppointmentsTable"
          ref="patientAppointmentsTable"
          name="patientAppointmentsTable"
          @row-click="rowClicked">
          <span slot="select" slot-scope="{row}">
            <span v-if="selectedRow !== null && row.id === selectedRow.id">
              <font-awesome-icon :icon="['fas', 'circle-check']" style="color: #7ccc70" />
            </span>
            <span v-else>
              <font-awesome-icon :icon="['far', 'circle']" style="color: #7ccc70" />
            </span>
          </span>
            <span slot="begin" slot-scope="{row}">
              {{ row.begin ? moment(row.begin).format("YYYY/MM/DD HH:mm") : "N/A" }}
            </span>
            <span slot="end" slot-scope="{row}">
              {{ row.end ? moment(row.end).format("YYYY/MM/DD HH:mm") : "N/A" }}
            </span>
        </v-server-table>
      </div>
    </va-card>

  </div>
</template>

<script>
import TableQueryMixin from "@/mixins/TableQueryMixin.vue";
import ApiService from "@/api/ApiService";
import axios from "axios";

export default {
  props: {
    appointmentDates: {
      type: Object,
      mandatory: true,
    },
    selectedPatientId: {
      type: Number,
      required: true
    },
  },
  mixins: [TableQueryMixin],
  mounted: function () {
    this.$refs.patientAppointmentsTable.setLimit(5)
  },
  data () {
    return {
      isLoading: false,
      selectedRow: null,
      queryUrl: `${this.$store.state.onecare_server}/appointments/patient/${this.selectedPatientId}`,
      columns: ['select', 'begin', 'end'],
      querySearch: '',
      tableOptions: {
        requestFunction: (data) => {
          const page = data.page
          return new Promise((resolve, reject) => {
            if (this.cancelationCallback !== null) {
              this.cancelationCallback()
            }
            this.isLoading = true
            const limit = this.$refs.patientAppointmentsTable ? this.$refs.patientAppointmentsTable.limit : 5
            const queryUrl = this.queryUrl
            if(this.appointmentDates.start === null || this.appointmentDates.end === null) {
              return
            }
            data.pageSize = limit
            data.from = this.appointmentDates.start
            data.to = this.appointmentDates.end
            data.byUpdate = false
            data.byBegin = true
            data.byEnd = false
            data.order_desc = true
            data.status = 3

            ApiService.cancelableQuery(queryUrl, data, new axios.CancelToken(c => {
              this.cancelationCallback = c
            }))
              .then(response => {
                if (response.data.page) {
                  if (this.getTableReference) {
                    this.getTableReference().$refs.pagination.Page = response.data.page
                  }
                } else if (page) {
                  if (this.getTableReference) {
                    this.getTableReference().$refs.pagination.Page = page
                  }
                }
                this.hasMadeFirstLoad = true
                resolve({
                  data: response.data.objects ? response.data.objects : [],
                  count: response.data.totalItems ? response.data.totalItems : 0,
                  page: response.data.page ? response.data.page : 1
                })
              })
              .catch(error => {
                if (!axios.isCancel(error)) {
                  reject(error)
                }
              })
              .finally(() => {
                this.isLoading = false
              })
          })
        },
        columnsDropdown: false,
        sortable: [],
        filterable: true,
        customFilters: ['from', 'to'],
        headings: {
          select: '',
          begin: this.$t('leads.agenda.start'),
          end: this.$t('leads.agenda.end')
        },
      },
    }
  },
  methods: {
    rowClicked: function ({row}) {
      if(this.selectedRow !== null && this.selectedRow.id === row.id) {
        this.selectedRow = null
      } else {
        this.selectedRow = row
      }
      this.$emit('selectedAppointment', this.selectedRow)
    },
    getTableReference: function () {
      return this.$refs.patientAppointmentsTable
    },
  },
  watch: {
    appointmentDates: {
      immediate: true,
      deep:true,
      handler (value) {
        if (this.getTableReference() !== undefined) {
          if (value.start !== null && value.end !== null) {
            this.getTableReference().customQueries.from = value.start
            this.emitTableFilter('vue-tables.patientAppointmentsTable.filter::to', value.end)
          }
        }
      }

    }
  }
}
</script>

<style scoped>

</style>
